import React from 'react'
import SkeletonElement from './SkeletonElement'

export default function SkeletonRow() {
  return (
    <tr>
      <td><SkeletonElement type="numbers" /></td>
      <td><SkeletonElement type="text" /></td>
      <td><SkeletonElement type="text" /></td>
      <td><SkeletonElement type="text" /></td>
    </tr>
  )
}
